import { apiClient } from "../api/apiclient";

export const requestResetOtp = (email) => {
  return apiClient.post("/auth/request-reset", { email });
};
export const changePassword = (currentPassword, newPassword, token) => {
  return apiClient.post(
    "/auth/change-password",
    { currentPassword, newPassword },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const confirmPasswordReset = (email, otp, newPassword) => {
  return apiClient.post("/auth/confirm-reset", {
    email,
    otp,
    newPassword,
  });
};

export const getAllUsers = (token) => {
  return apiClient.get("/allusers", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const verifyUser = (request, token) =>
  apiClient.patch("/admin/verify-user", request, {
    headers: { Authorization: `Bearer ${token}` },
  });

